import PerfectScrollbar from 'react-perfect-scrollbar'
import React, { useState } from 'react'
import DOMPurify from 'dompurify'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { Avatar, Box, colors, Paper, Typography } from '@material-ui/core'

import { AttachmentItems, Notification } from './components'

import helpers from 'helpers'

import theme from 'theme'
import styles from './styles'
import constants from 'constants/index'

const TicketMessages = ({
  attachments,
  author,
  boxColor = colors.lightGreen['A100'],
  content,
  iconColor = colors.lightGreen[800],
  interactions = [],
  sourceType,
  subTitle,
  title,
}) => {
  const { SYSTEM_SOURCE_TYPE } = constants.ticketMessages

  const { avatarLetters } = helpers

  const useStyles = styles({ boxColor, iconColor })
  const classes = useStyles()

  const messageSanitizer = DOMPurify.sanitize(content, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
  })

  const isSystem = sourceType === SYSTEM_SOURCE_TYPE

  return (
    <>
      {interactions?.map((notification, index) => (
        <Notification key={index} interaction={notification} />
      ))}
      <Paper component={Box} width="100%">
        <Box className={classes.boxTitle}>
          <Box display="flex" gridGap={theme.spacing(2)}>
            {author && !isSystem && (
              <Box>
                <Avatar>{avatarLetters(author)}</Avatar>
              </Box>
            )}
            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              overflow="hidden"
            >
              <Typography
                variant={!!subTitle ? 'body1' : 'h6'}
                color="primary"
                className={classes.messageInfo}
              >
                {isSystem ? 'Resposta automática' : author || title}
              </Typography>
              {!!subTitle && (
                <Typography variant="body2" color="secondary">
                  {subTitle}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
        <Box
          className={classes.boxContent}
          dangerouslySetInnerHTML={{
            __html: messageSanitizer,
          }}
        />
        {!isEmpty(attachments) && (
          <PerfectScrollbar
            options={{
              wheelPropagation: true,
              suppressScrollY: true,
            }}
          >
            <Box display="flex" pb={2} px={2} gridGap={theme.spacing(2)}>
              {attachments?.map((attachment, index) => (
                <AttachmentItems
                  key={index}
                  name={attachment?.name}
                  url={attachment?.url}
                />
              ))}
            </Box>
          </PerfectScrollbar>
        )}
      </Paper>
    </>
  )
}

TicketMessages.propTypes = {
  attachments: PropTypes.array,
  author: PropTypes.string,
  content: PropTypes.string,
  interactions: PropTypes.array,
  sourceType: PropTypes.string,
  subTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default TicketMessages
